import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchDataMaxPageExceededProps as Props } from './types';

export const SearchDataMaxPageExceeded = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('SearchDataMaxPageExceeded', className)}
      title="dasdsa"
    >
      <Styled.Title gap={0.5} flexDirection="row">
        <Icon name="danger-fill" sxx={SX.iconsSX} size={30} />
        <Typography color="error" fontWeight="inherit">
          Error
        </Typography>
      </Styled.Title>

      <Styled.Content>
        <Typography variant="body2" color="text.primary">
          Page number not supported
        </Typography>
      </Styled.Content>
    </Styled.Wrapper>
  );
});

SearchDataMaxPageExceeded.displayName = 'SearchDataMaxPageExceeded';
